import React from "react";
import PropTypes from "prop-types";

import { MyDraggable as Draggable } from "../components/Core";
import HoverBar from "../components/HoverBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { generateStyle, setOverLay, l } from "../functions";
import Icon from "../components/Icons";

import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

const mapStateToProps = (state) => {
  return {
    currentLang: state.rootReducer.currentLang || 1,
    settings: state.rootReducer?.appearanceSettings || {},
  };
};

class HtmlCode extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  shouldComponentUpdate(nextProp, nextState) {
    const currentPayload = this.props?.payload;
    const nextPayload = nextProp?.payload;

    // console.log(JSON.stringify(currentPayload) === JSON.stringify(nextPayload));
    if (!isEqual(currentPayload, nextPayload)) {
      return true;
    }
    // console.log("re-render");
    return false;
  }

  _initCode = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    let htmlCode = "";

    if (payload.datas) {
      if (payload.datas["htmlCode_" + this.props.currentLang])
        htmlCode = payload.datas["htmlCode_" + this.props.currentLang];
      else if (payload.datas["htmlCode"]) htmlCode = payload.datas.htmlCode;
    }

    const cssSettings = generateStyle(payload, "container");

    return (
      <Container fluid={payload.fullContainer}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12}>
            {(htmlCode && (
              <div style={cssSettings}>
                <div className="gk-error-message inline">
                  <p>
                    {l(
                      "This is an area of HTML element. It will not be displayed here. Please check your live website."
                    )}
                  </p>
                </div>
              </div>
            )) || (
              <div className="gk-error-message">
                <p>{l("Please add your html code.")}</p>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      return (
        <Draggable {...this.props} side={true}>
          {(options.showPreview && this._initCode()) || (
            <span className="dragger">
              {(Array.isArray(rest.icon) && (
                <FontAwesomeIcon icon={rest.icon} />
              )) || <Icon icon={rest.icon} />}
              <span>{l(rest.name)}</span>
            </span>
          )}
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initCode()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initCode()}
      </Draggable>
    );
  }
}

HtmlCode.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(HtmlCode);
